import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import './cocodi.css';

function Cocodi() {
  return (
    
  <div>
    <div className='row'>
      <div className="fixed-header">
        <h3 className='title'>Comité de Control y Desempeño Istitucional<br />de la Secretaría de Desarrollo Social</h3>
        <hr className='hr-gob' />
      </div>
    </div>

   
      {/* Contenedor con clase para aplicar ancho de un tercio */}
      <div className="accordion-container">
        <Accordion>
          <Accordion.Item eventKey="1" className="accordion-CONTR1">
            <Accordion.Header>Normatividad</Accordion.Header>

            <Accordion.Body>
            Acuerdo que crea el Comité de Control y Desempeño Institucional
              <a href="/Cocodi/Cocodidoc01">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            
          </Accordion.Item>
          
        </Accordion>
      </div>

    </div>





  );
}

export default Cocodi;
